<template>
    <div>
        <SideBarBg>
            <div class="w-full h-[2px] bg-gradient-to-r from-transparent via-slate-700 to-transparent shadow-inner"></div>
            <router-link :to="{ name: 'dashboard' }"
                class="w-full flex items-center rounded-md hover:bg-slate-700 my-1 p-2"
                active-class="theme-color">
                <font-awesome-icon icon="fa-solid fa-dashboard" class="text-white text-2xl" />
                <p v-if="isOpen" class="w-full text-slate-100 px-4 overflow-hidden whitespace-nowrap">داشبورد</p>
            </router-link>
            <div class="w-full h-[2px] bg-gradient-to-r from-transparent via-slate-700 to-transparent shadow-inner"></div>
            <router-link :to="{ name: 'myAssetsAndRequests' }"
                class="w-full flex items-center rounded-md hover:bg-slate-700 my-1 p-2"
                active-class="theme-color">
                <font-awesome-icon icon="fa-solid fa-boxes-packing" class="text-white text-2xl" />
                <p v-if="isOpen" class="w-full text-slate-100 px-4 overflow-hidden whitespace-nowrap">اموال من</p>
            </router-link>
            <div class="w-full h-[2px] bg-gradient-to-r from-transparent via-slate-700 to-transparent shadow-inner"></div>
            <router-link :to="{ name: 'management' }"
                class="w-full flex items-center rounded-md hover:bg-slate-700 my-1 p-2"
                active-class="theme-color">
                <font-awesome-icon icon="fa-solid fa-list-check" class="text-white text-2xl" />
                <p v-if="isOpen" class="w-full text-slate-100 px-4 overflow-hidden whitespace-nowrap">مدیریت اموال</p>
            </router-link>
            <div class="w-full h-[2px] bg-gradient-to-r from-transparent via-slate-700 to-transparent shadow-inner"></div>
            <router-link :to="{ name: 'places' }"
                class="w-full flex items-center rounded-md hover:bg-slate-700 my-1 px-[0.33rem] py-3"
                active-class="theme-color">
                <font-awesome-icon icon="fa-solid fa-warehouse" class="text-white text-2xl" />
                <p v-if="isOpen" class="w-full text-slate-100 px-4 overflow-hidden whitespace-nowrap">فضاها</p>
            </router-link>
            <div class="w-full h-[2px] bg-slate-500 shadow-inner"></div>
            <a href="https://auth.moallem.sch.ir/"
                class="w-full flex items-center rounded-md hover:bg-slate-700 my-1 p-2 cursor-pointer"
                active-class="theme-color">
                <font-awesome-icon icon="fa-solid fa-home-alt" class="text-white text-2xl" />
                <p v-if="isOpen" class="w-full text-slate-100 px-4 overflow-hidden whitespace-nowrap">سامانه مرکزی</p>
            </a>
            <div class="w-full h-[2px] bg-gradient-to-r from-transparent via-slate-700 to-transparent shadow-inner"></div>
        </SideBarBg>
    </div>
</template>

<script setup>
import { provide, ref } from "vue";
import SideBarBg from "@/components/SideBarBg.vue"

const isOpen = ref(false);

provide("status", isOpen);
</script>